// eslint-disable-next-line import/prefer-default-export
export const CITY_OPTIONS = [
  {
    id: '57',
    name: 'Минск',
    nameFrom: 'Минска',
  },
  {
    id: '1',
    name: 'Москва',
    nameFrom: 'Москвы',
  },
  {
    id: '70',
    name: 'Брест',
    nameFrom: 'Бреста',
  },
  {
    id: '71',
    name: 'Витебск',
    nameFrom: 'Витебска',
  },
  {
    id: '69',
    name: 'Гомель',
    nameFrom: 'Гомеля',
  },
];
